import { render } from "./MetadataRecord.vue?vue&type=template&id=fbbf4e62&scoped=true&ts=true"
import script from "./MetadataRecord.vue?vue&type=script&lang=ts"
export * from "./MetadataRecord.vue?vue&type=script&lang=ts"

import "./MetadataRecord.vue?vue&type=style&index=0&id=fbbf4e62&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbbf4e62"]])

export default __exports__